import decorativo from '../../../Assets/img/shape13.svg'
import { Hero } from '../Components/Hero'
import { PorQueElegirnos } from '../Components/PorQueElegirnos'
import PropuestaValor from '../Components/PropuestaValor'
import Asesoramiento from '../Components/Asesoramiento'
import Formulario from '../Components/Formulario';
import useSEOConfig from "../../../hooks/seo/useSEOConfig"
import { Navbar } from "../Components/Navbar"
import { useConfig } from '../../../context/ConfigContext'
import { useLocation } from 'react-router-dom'
import { buscarTextoSeo } from '../../../utils/buscarTextoSeo'

export const Credito = () => {

    const { config } = useConfig();
    const location = useLocation();
    const textoSeo = buscarTextoSeo(location.pathname, config.pais);

    useSEOConfig(
        {
            title: textoSeo?.title ?? "Seguros para Empresas & Pymes - Protegé tu inversión ante todo riesgo",
            description: textoSeo?.description ?? "Conocé la amplia variedad de seguros que tenemos para vos · Auto · Accidentes Personales · Moto · Hogar · Asistencia al viajero · Mala Praxis · Vida · Celular",
            tituloCompleto: !!textoSeo,
            keywords: "Seguros de Auto, Seguro para moto, Seguros económicos, Cotizar seguro de auto, Seguro Mala praxis, Seguro online, Asistencia al viajero, Aseguradoras, Seguros rivadavia, Seguro flota, Cotizar seguro",
            ogTitle: "Segurarse - Bróker Integral de Seguros digitales",
            ogDescription: "Contratá el seguro que necesitás en pocos pasos. Seguros personales a tu medida al mejor precio. Te asesoramos en todo momento ¡Invertí en tu tranquilidad!",
            twitterCard: "summary_large_image",
        }
    )

    return (
        <>
            <Navbar rubro='auto' />
            <div style={{ backgroundColor: "white" }}>
                <Hero
                    titulo='Seguro de Crédito'
                    url='#formulario'
                    icon='#icon-seg-credito'
                    subTitulo={{ __html: "Protegé a tu empresa ante el riesgo de incumplimientos de pago de cuentas a cobrar.<br/><br/>¿Empezamos?" }}
                />
                <div className="pt-70 pt-lg-80 pb-40 bg-primary position-relative">
                    <img
                        className="d-none d-lg-block pos16 blend-multipy"
                        src={decorativo}
                        alt="Decorative Shape"
                    />
                    <div className="container">
                        <h2 className="ff-mukta fw-bold fs-30 fs-lg-40 text-white text-center mb-16 mb-lg-25">
                            ¿Qué cubre?
                        </h2>
                        <div className="col-10 col-lg-12 mx-auto">
                            <p className="fs-17 fs-lg-20 lh-13 text-white text-center mb-16 mb-lg-20">
                                El seguro de crédito es una herramienta financiera diseñada para proteger a las empresas del riesgo de no pago, causado por una insolvencia declarada, una quiebra, cesación de pago con acreedores u otros escenarios similares, proporcionando cobertura y compensación ante un escenario de derechos a cobrar impagos.
                            </p>
                            <p className="fs-17 fs-lg-20 lh-13 text-white text-center mb-16 mb-lg-20">
                                Dentro de las principales coberturas, se incluyen:
                            </p>
                        </div>

                        <div className="px-20 px-lg-0 maxw-lg-920p mx-auto">
                            <div className="row gx-lg-80">
                                <div className="col">
                                    <ul className="list-unstyled list-bullet-md fs-16 lh-14 mb-0 text-white">
                                        <li className="bullet-check-primary ps-35 ps-lg-45 border-bottom border-2 border-white border-opacity-25">
                                            <b>Riesgo de impago:</b> protege a la empresa asegurada contra el riesgo de que sus clientes no paguen las facturas o cuentas por cobrar. Si un cliente se vuelve insolvente o no cumple con sus obligaciones de pago, el seguro de crédito puede indemnizar a la empresa por las pérdidas sufridas.
                                        </li>
                                        <li className="bullet-check-primary ps-35 ps-lg-45 border-bottom border-2 border-white border-opacity-25">
                                            <b>Evaluación y control de riesgo:</b> los aseguradores de crédito realizan un análisis de riesgo de los clientes potenciales de la empresa para evaluar su capacidad crediticia. Esto ayuda a la empresa a tomar decisiones informadas sobre el otorgamiento de crédito y a evitar clientes con alto riesgo de impago.
                                        </li>
                                        <li className="bullet-check-primary ps-35 ps-lg-45 border-bottom border-2 border-white border-opacity-25">
                                            <b>Cobertura de deudas vencidas:</b> cobertura de las cuentas por cobrar que están vencidas y no se han pagado. Si un cliente no paga una factura dentro del plazo acordado, la empresa puede presentar un reclamo ante la aseguradora para recuperar el monto adeudado.
                                        </li>
                                        <li className="bullet-check-primary ps-35 ps-lg-45 border-bottom border-2 border-white border-opacity-25 border-lg-none">
                                            <b>Servicios de cobranza y recuperación:</b> en algunos casos las pólizas incluyen este servicio que permite optimizar y agilizar el proceso de cobranza.
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <Formulario
                    rubro='Creditos'
                    titulo='Cotizá seguro de Crédito'
                />
                <PorQueElegirnos />
                <PropuestaValor />
                {/* <Asesoramiento /> */}
            </div>
        </>
    )
}
